import { getOssProxyOrFail } from "../api";

export async function getMetriportPatientId(patientId: string): Promise<string> {
  const apiOssProxy = getOssProxyOrFail();
  const resp = await apiOssProxy.get(`/patient/${patientId}`);
  if (!resp.data) throw new Error(`Patient ID not returned @ EClinicalWorks`);
  return resp.data;
}
